import { updatedIpPhoneSettings } from "./actions";
import { IpPhoneSettings } from "./reducer";

const IP_PHONE_EVENT_TYPE_PREFIX = "ipPhone/";

export const IP_PHONE_EVENT_TYPES = {
  IP_PHONE_SETTINGS_UPDATE_REQUEST: `${IP_PHONE_EVENT_TYPE_PREFIX}settings-update-request`,
  IP_PHONE_SETTINGS_UPDATE_RESPONSE: `${IP_PHONE_EVENT_TYPE_PREFIX}settings-update-response`,
};

export const handleIncomingMessage = (store: any) => (type: string, payload: any) => {
  if (!type.startsWith(IP_PHONE_EVENT_TYPE_PREFIX)) {
    return;
  }

  const {
    settings,
  }: {
    settings: IpPhoneSettings;
  } = payload;

  switch (type) {
    case IP_PHONE_EVENT_TYPES.IP_PHONE_SETTINGS_UPDATE_RESPONSE:
      store.dispatch(updatedIpPhoneSettings(settings));
      break;
    default:
      break;
  }
};
